import React, { useState, useRef, useEffect } from "react";
import { BsX } from "react-icons/bs";
import "./GlobalStyle.css";
import { getComments, getEmployeeDetails, sendWishes } from "../../api/ApiConfig";
import toast from "react-hot-toast";

export default function WishModal({
  show,
  handleClose,
  onSend,
  recipientEmail,
}) {
  const [message, setMessage] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const modalRef = useRef(null);
  const [employeeDetails, setEmployeeDetails] = useState({});


   const fetchEmployeeData = async () => {
      try {
        const data = await getEmployeeDetails();
        if (data) {
          setEmployeeDetails(data);
        } else {
          setEmployeeDetails({});
        }
      } catch (error) {
        setEmployeeDetails({});
      }
    };
  
   


  // Close modal on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        handleClose();
      }
    }
    if (show) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [show, handleClose]);

  // Reset message when modal closes
  useEffect(() => {
    if (!show) setMessage("");
  }, [show]);

  // Fetch comments of type "wish" when modal is shown
  useEffect(() => {
    fetchEmployeeData();
    if (show) {
      const fetchSuggestions = async () => {
        try {
          const response = await getComments({ type: "wish" });

          if (response?.data) {
            // Extract just the comments from the response data array
            const commentTexts = response.data.map((item) => item.comments);
            setSuggestions(commentTexts);
          }
        } catch (err) {
          console.error("Error fetching wish comments:", err);
          // Fallback to default suggestions if API fails
          setSuggestions(['"Welcome to Ahana"', '"Congrats"']);
        }
      };
      fetchSuggestions();
    }
  }, [show]);

  const handleSuggestionClick = (text) => {
    setMessage(text);
  };

  const handleSend = async () => {
    try {
      const userData = {
        to: recipientEmail,
        comments: message,
      };
      const sendWishRes = await sendWishes(userData);
      toast.success(sendWishRes.message);
      handleClose();
    } catch (error) {
      toast.success(error.message);
    }
  };

  if (!show) return null;

  const getInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    const first = parts[0]?.[0] || "";
    const second = parts[1]?.[0] || "";
    return (first + second).toUpperCase();
  };
  
  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-container-wish" ref={modalRef}>
        <div className="custom-modal-header">
          <p className="head">Send Wishes</p>
          <button className="custom-modal-close" onClick={handleClose}>
            <BsX size={20} />
          </button>
        </div>
        <div className="custom-modal-body">
          <div className="input-with-profile">
          <div className="avatar mt-2">{getInitials(employeeDetails.name)}</div>
            <textarea
              className="custom-modal-textarea"
              placeholder="Type Your Message here..."
              value={message}
              disabled
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>

          <div className="suggestion-container p-2">
            {suggestions.length > 0 ? (
              suggestions.map((txt, i) => (
                <button
                  key={i}
                  className="suggestion-btn"
                  onClick={() => handleSuggestionClick(txt)}
                >
                  {txt}
                </button>
              ))
            ) : (
              <p>No suggestions available</p>
            )}
          </div>
        </div>

        <div className="post-container">
          <button
            className="send-wish-but"
            onClick={handleSend}
            disabled={!message.trim()}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}
